export const bookList=[
  {
    'list':[{
      shId: 'fN1tg',
      cover: 'http://imgb2.chineseall.cn/bookcover/692/158/18/61169633.jpg',
      name: '顺应二十四节气饮食健康100分',
      author: '王璐璐主编',
      intro: '二十四节气是自然现象，自然界的兴衰枯荣都会对人体健康产生影响。就其气候而论，春季温和，夏季炎热，秋季干燥，冬季寒冷，人体的生理也随着时节的变化而变化，而为人体提供所需营养的饮食与人的健康又有着密切的关系。所以，人的饮食养生也必须顺应时节，符合四季二十四节气更替变化的客观规律，达到健康长寿的目的。《二十四节气饮食健康100分》以二十四节气进行划分，全篇分上下两篇，上篇进行总述，下篇拟为24节，每个节气为一节。通过对每个节气的由来、气候特征分析，依据每个时节人体特征，进行每个时节的饮食特征分析，推荐相应的时令蔬果，以及该节气易发病症的食疗途径及丰富的食谱，让饮食健康获得100分。',
      url: '/v3/book/detail/fN1tg',
      wUrl: '/book/detail/fN1tg/cover'
    },
    {
      shId: 'mFOqg',
      cover: 'http://imgb2.chineseall.cn/bookcover/169/679/838/61342588_st_300_400.jpg',
      name: '好姑娘下厨房',
      author: '郭婧著',
      intro: '全书按照四季划分章节，有“春的秘密花园”“夏的凉爽和风”“秋的时光滋味”“冬的暖胃暖心”。其内容囊括点心、下午茶、简餐、甜品等各种菜谱。设计新颖，版式活泼。用轻松可爱的图文，学些大厨做的菜。即使是厨房小白，也能轻松驾驭。',
      url: '/v3/book/detail/mFOqg',
      wUrl: '/book/detail/mFOqg/cover'
    },
    {
      shId: 'EBPBg',
      cover: 'http://imgb2.chineseall.cn/bookcover/996/414/306/61161961.jpg',
      name: '大吃包家的四季餐桌',
      author: '大吃包著',
      intro: '这本书介绍了80多道四季美食，还为重要日子(如节日、孩子大考日等)细心搭配了营养套餐，让读者感受最温暖的家的味道。这些美食按照春夏秋冬四季来分类，突出了顺应四季变化、采用应季食材来进行营养搭配。每一道美食都给出了主料和调料的精准用量、所需时间、难易程度、营养功效、适宜人群、推荐的搭配吃法以及制作过程的详细图片和文字说明，让读者跟着操作就可以做出来。',
      url: '/v3/book/detail/EBPBg',
      wUrl: '/book/detail/EBPBg/cover'
    }]
  },
  {
    'list':[{
      shId: 'HTJMg',
      cover: 'http://imgb2.chineseall.cn/bookcover/187/890/590/61210005_st_300_400.jpg',
      name: '跟着节气读唐诗',
      author: '秦金华，温潇主编',
      intro: '“二十四节气”是我国古代劳动人民认识世界、认识自然的智慧结晶，是流淌在中华民族血液中的文化基因。《义务教育语文课程标准》2011版在“课程资源开发与利用的建议”第4点明确提出：“语文教师应高度重视课程资源的开发与利用，创造性地开展各类活动，增强学生在各种场合学语文、用语文的意识，通过多种途径提高学生的语文素养。”2016年11月30日，中国“二十四节气”正式列入联合国教科文组织人类非物质文化遗产名录。党的十九大报告也特别强调要弘扬中华传统文化。本书将中国传统文化的“二十四节气”与唐诗结合起来，按照春夏秋冬四季分为四个单元，每个单元对应六个节气，每个节气精选“课前导读、课堂选读、课后拓展”三首唐诗，通过学习“节气诗”，帮助青少年在唐诗鉴赏过程中更好地感悟以二十四节气为代表的中国传统文化，增强我们的文化自信。',
      url: '/v3/book/detail/HTJMg',
      wUrl: '/book/detail/HTJMg/cover'
    },{
      shId: 'bLyIg',
      cover: 'http://imgb2.chineseall.cn/bookcover/161/666/498/61177078_st_300_400_1.jpg',
      name: '二十四节气文化知识日历',
      author: '吕仁和，黄道京主编',
      intro: '作为中国历法的独特创造，二十四节气于2016年11月30日被正式列入联合国教科文组织人类非物质文化遗产代表作名录。本日历正是以中国农历中表示季节变迁的这二十四个特定节令为主线，融合相关的传统文化和养生知识，同时编选古代诗、词、文、画，艺术性、知识性、实用性三结合，图文并茂，引人入胜，以期给读者以生活帮助和艺术熏陶。',
      url: '/v3/book/detail/bLyIg',
      wUrl: '/book/detail/bLyIg/cover'
    }
    ]
  },
  {
    'list':[
    {
      shId: '4rxtg',
      cover: 'http://imgb2.chineseall.cn/bookcover/298/755/619/61169239.jpg',
      name: '神奇的二十四节气·冬',
      author: '稚子文化编绘',
      intro: '“神奇的二十四节气”是一套新颖生动的自然科普绘本。全书按照一年二十四节气的时间顺序，用大幅精美的图画讲述二十四节气这项古老发明的历史由来以及它对我们当下生活的影响和启示，揭示了自然界的魅力和农业的趣味。书中涉及知识面广，编排清晰简明，选材紧贴儿童心理和求知特点，有助于拓展和激发孩子的博物兴趣，对于传统文化启蒙和自然科学教育都是不可多得的优良读物。同时让孩子知晓，无论生活如何变化，我们应该关注农业农村，关注纯粹的自然，关注我们衣食的初来源。',
      url: '/v3/book/detail/4rxtg',
      wUrl: '/book/detail/4rxtg/cover'
    }

  ]
  }
  
]
